import axios from "axios";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { saleReturnInfo, saleReturnProducts } from "../../../features/posSlice";
import { signInUser } from "../../Utility/Auth";
import PosSearchReturnProduct from "../CustomSelect/PosSearchReturnProduct";
import * as Icons from "heroicons-react";

const ReturnModal = ({
  title,
  onShow,
  handleClose,
  returnProducts,
  setReturnProducts,
  // reCal,
  // setReCal,
  updateCart,
  handleReturnCustomerSelect,
  invoice,
  setInvoice,
}) => {
  const posSaleData = useSelector((state) => state.posReducer);
  const [returnInvoice, setReturnInvoice] = useState({});
  const [isVoid, setIsVoid] = useState(false);
  const dispatch = useDispatch();
  const auth = signInUser();
  const { aamarId } = auth;

  const BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
  const handleChangeInvoiceId = async (e) => {
    const id = e.target.value;
    const sale = await axios
      .get(`${BASE_URL}sale/invoice/${aamarId}/${id}`)
      .then((res) => {
        // console.log("return:", res.data);
        setReturnInvoice(res.data);
        // ReturnInvoice
        dispatch(
          saleReturnInfo({
            // returnInvoice
            returnInvoice: res.data?._id,
            // Customer Info
            customerId: res.data.customerId?._id,
            customerPhone: res.data.customerId?.phone,
            customerName: res.data.customerId?.name,
            customerPoint: res.data.customerId?.point,
          })
        );
        dispatch(saleReturnProducts([]));
        setInvoice(res.data);
        setReturnProducts([]);
      });
  };

  useEffect(() => {
    updateCart();
  }, [posSaleData.returnProducts]);

  // console.log("return product", posSaleData.returnProducts);

  const handleAddToggleProduct = (e, product) => {
    const maxAllowed =
      product?.max_qty !== undefined
        ? Number(product.max_qty)
        : product?.remainingQty !== undefined
        ? Number(product.remainingQty)
        : Number(product?.qty);

    if (maxAllowed <= 0) return;

    const rest = posSaleData.returnProducts.filter(
      (item) => item.article_code !== product.article_code
    );
    let returnList = [];
    if (e.target.checked) {
      returnList = [
        { ...product, qty: maxAllowed, max_qty: maxAllowed },
        ...rest,
      ];
    } else {
      returnList = rest;
    }
    dispatch(saleReturnProducts(returnList));
    if (typeof setReturnProducts === "function") {
      setReturnProducts(returnList);
    }
  };

  const handleCancel = () => {
    if (typeof setReturnProducts === "function") {
      setReturnProducts([]);
    }
    setInvoice({});
    dispatch(saleReturnProducts([]));
    handleClose();
  };

  const handleCustomQty = (article_code, qty, cartProduct) => {
    const product =
      cartProduct ||
      posSaleData.returnProducts.find((p) => p.article_code === article_code) ||
      invoice?.products?.find((p) => p.article_code === article_code);

    const maxAllowed =
      product?.max_qty !== undefined
        ? Number(product.max_qty)
        : product?.remainingQty !== undefined
        ? Number(product.remainingQty)
        : isVoid
        ? Infinity
        : Number(product?.qty);

    if (!isVoid && maxAllowed <= 0) return;

    const numQty = parseFloat(qty);
    let validQty = isNaN(numQty) || numQty <= 0 ? 1 : numQty;
    if (maxAllowed !== undefined && validQty > maxAllowed) {
      validQty = maxAllowed;
    }

    const isAlreadyInCart = posSaleData.returnProducts.some(
      (item) => item.article_code === article_code
    );

    let updated = [];
    if (isAlreadyInCart) {
      updated = posSaleData.returnProducts.map((item) =>
        item.article_code === article_code
          ? { ...item, qty: validQty, max_qty: maxAllowed }
          : item
      );
    } else {
      const rest = posSaleData.returnProducts.filter(
        (item) => item.article_code !== article_code
      );
      updated = [
        { ...product, qty: validQty, max_qty: maxAllowed },
        ...rest,
      ];
    }
    dispatch(saleReturnProducts(updated));
    if (typeof setReturnProducts === "function") {
      setReturnProducts(updated);
    }
  };

  const removeItemFromReturnCart = (article_code) => {
    const rest = posSaleData.returnProducts.filter(
      (item) => item.article_code !== article_code
    );

    // console.log("REMOVE ITEM", rest);

    dispatch(saleReturnProducts(rest));
  };

  let i = 1;
  return (
    <Modal size="lg" show={onShow} onHide={handleClose}>
      <Form>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 h5">
            <div className="row d-flex  ">
              <div className="col-10">
                <span>
                  {title} |{" "}
                  {isVoid
                    ? "Void Return"
                    : invoice?.invoiceId
                    ? `Invoice No: ${invoice?.invoiceId}`
                    : "Please Scan An Invoice"}
                </span>
              </div>
              <div className="col-2">
                <div className=" float-end ms-4">
                  <div class="form-check form-switch">
                    <label
                      class="form-check-label text-sm"
                      for="flexSwitchCheckDefault"
                    >
                      Void
                    </label>
                    <input
                      class="form-check-input"
                      style={{
                        backgroundColor: isVoid ? "black" : "",
                        borderColor: isVoid ? "black" : "",
                        outline: "none",
                        boxShadow: "none",
                      }}
                      type="checkbox"
                      checked={isVoid}
                      onChange={() => setIsVoid(!isVoid)}
                      role="switch"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isVoid ? (
            <Container>
              <Row>
                <Col xs={12} md={2}>
                  Void Return
                </Col>
                <Col xs={6} md={10}>
                  <Form.Group className="mb-3" controlId="invoiceId">
                    <PosSearchReturnProduct />
                  </Form.Group>
                </Col>
                <hr />
                <Col xs={12} md={12}>
                  <table className="table mt-3">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Product</th>
                        <th scope="col">Price</th>
                        <th scope="col">Quantity</th>
                        {/* <th scope="col">Vat</th> */}
                        <th scope="col">Sub-Total</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>

                    <tbody className="cart-list">
                      {posSaleData?.returnProducts?.length > 0 &&
                        posSaleData?.returnProducts
                          ?.slice()
                          ?.sort((a, b) => a.order - b.order)
                          ?.map((cartItem) => (
                            <tr key={cartItem?.article_code}>
                              <th scope="row">
                                {/* <Icons.Plus size="28" /> */}
                                {i++}
                              </th>
                              <td title={cartItem?.article_code}>
                                {cartItem?.name}
                              </td>
                              <td>{cartItem?.mrp}</td>
                              <td className="col-md-2">
                                <input
                                  type="number"
                                  min="1"
                                  className="form-control form-control-sm text-center"
                                  value={cartItem?.qty}
                                  onChange={(e) =>
                                    handleCustomQty(
                                      cartItem.article_code,
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              {/* <td>
                                {(
                                  (cartItem?.vat / 100) *
                                  cartItem?.mrp *
                                  cartItem?.qty
                                )?.toFixed(2)}
                              </td> */}
                              <td className="">
                                {(cartItem?.mrp * cartItem?.qty)?.toFixed(2)}
                              </td>
                              <td className="text-center">
                                <Icons.X
                                  size={20}
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    removeItemFromReturnCart(
                                      cartItem.article_code
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Container>
          ) : (
            <Container>
              <Row>
                <Col xs={12} md={2}>
                  Scan Invoice
                </Col>
                <Col xs={6} md={10}>
                  <Form.Group className="mb-3" controlId="invoiceId">
                    <Form.Control
                      type="text"
                      onChange={(e) => handleChangeInvoiceId(e)}
                      placeholder="Scan Invoice here"
                    />
                  </Form.Group>
                </Col>
                <hr />
              </Row>
              {Object.keys(invoice).length > 0 ? (
                <>
                  <Row>
                    <Col xs={12} md={3}>
                      <p>
                        <b>Client: </b>
                        {invoice?.customerId?.phone}
                      </p>
                    </Col>
                    <Col xs={12} md={4}>
                      <p>
                        <b>Biller:</b> {invoice?.billerId?.name}
                      </p>
                    </Col>
                    <Col xs={12} md={3}>
                      <p>
                        <b>Date:</b>{" "}
                        {invoice?.createdAt &&
                          format(new Date(invoice?.createdAt), "MM-dd-yyyy")}
                      </p>
                    </Col>
                    <Col xs={12} md={2}>
                      <p>
                        <b>Old:</b> {invoice?.point?.old}
                      </p>
                    </Col>
                    <Col xs={12} md={2}>
                      <p>
                        <b>Item No:</b> {invoice?.totalItem}
                      </p>
                    </Col>
                    <Col xs={12} md={3}>
                      <p>
                        <b>Total:</b>{" "}
                        {invoice?.total && invoice?.total?.toFixed(2)}
                      </p>
                    </Col>
                    <Col xs={12} md={2}>
                      <p>
                        <b>Vat:</b> {invoice?.vat}
                      </p>
                    </Col>
                    <Col xs={12} md={3}>
                      <p>
                        <b>Round Total:</b> {invoice?.grossTotalRound}
                      </p>
                    </Col>
                    <Col xs={12} md={2}>
                      <p>
                        <b>New:</b> {invoice?.point?.new}
                      </p>
                    </Col>

                    <Col xs={12} md={12}>
                      <table className="table mt-3">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Product</th>
                            <th scope="col">Price</th>
                            <th scope="col" className="text-center">
                              Quantity
                            </th>
                            {/* <th scope="col">Vat</th> */}
                            <th scope="col" className="text-end">
                              Sub-Total
                            </th>
                          </tr>
                        </thead>
                        <tbody className="cart-list">
                          {invoice?.products?.length > 0 &&
                            invoice?.products?.map((cartItem) => {
                              const maxAllowed =
                                cartItem?.max_qty !== undefined
                                  ? Number(cartItem.max_qty)
                                  : cartItem?.remainingQty !== undefined
                                  ? Number(cartItem.remainingQty)
                                  : Number(cartItem?.qty);
                              const isReturnedOut = maxAllowed <= 0;
                              const selectedReturnItem =
                                posSaleData?.returnProducts?.find(
                                  (x) =>
                                    x.article_code === cartItem.article_code
                                );
                              const isChecked = Boolean(selectedReturnItem);
                              const currentQty = isChecked
                                ? selectedReturnItem.qty
                                : isReturnedOut
                                ? 0
                                : maxAllowed;

                              return (
                                <tr key={cartItem?.article_code}>
                                  <th scope="row">
                                    <Form.Check
                                      inline
                                      disabled={isReturnedOut}
                                      checked={isChecked}
                                      name="group1"
                                      onChange={(e) =>
                                        handleAddToggleProduct(e, cartItem)
                                      }
                                    />
                                  </th>
                                  <td title={cartItem?.article_code}>
                                    {cartItem?.name}
                                    {isReturnedOut && (
                                      <span
                                        className="badge bg-danger ms-2"
                                        style={{ fontSize: "10px" }}
                                      >
                                        Already Returned
                                      </span>
                                    )}
                                  </td>
                                  <td>{cartItem?.mrp}</td>
                                  <td className="col-md-2 text-center">
                                    <input
                                      type="number"
                                      min="1"
                                      max={maxAllowed}
                                      disabled={isReturnedOut}
                                      className="form-control form-control-sm text-center"
                                      value={currentQty}
                                      onChange={(e) =>
                                        handleCustomQty(
                                          cartItem.article_code,
                                          e.target.value,
                                          cartItem
                                        )
                                      }
                                    />
                                    {cartItem?.returnedQty > 0 ? (
                                      <small
                                        className="text-muted d-block mt-1"
                                        style={{ fontSize: "11px" }}
                                      >
                                        (Rem: {maxAllowed} / Sold:{" "}
                                        {cartItem?.soldQty || cartItem?.qty})
                                      </small>
                                    ) : (
                                      <small
                                        className="text-muted d-block mt-1"
                                        style={{ fontSize: "11px" }}
                                      >
                                        (Max: {maxAllowed})
                                      </small>
                                    )}
                                  </td>
                                  <td className="text-end">
                                    {(cartItem?.mrp * currentQty)?.toFixed(2)}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  {posSaleData?.returnProducts?.length > 0 && (
                    <Row>
                      <Col xs={12} md={12}>
                        <p>
                          <b>Return Info</b>
                          <hr />
                        </p>
                      </Col>
                      <Col xs={12} md={2}>
                        <p>
                          <b>Item No:</b>{" "}
                          {posSaleData?.returnCal?.totalItem || 0}
                        </p>
                      </Col>
                      <Col xs={12} md={2}>
                        <p>
                          <b>Total:</b>{" "}
                          {parseFloat(
                            posSaleData?.returnCal?.total || 0
                          )?.toFixed(2)}
                        </p>
                      </Col>
                      <Col xs={12} md={2}>
                        <p>
                          <b>Vat:</b>{" "}
                          {parseFloat(
                            posSaleData?.returnCal?.vat || 0
                          )?.toFixed(2)}
                        </p>
                      </Col>
                      <Col xs={12} md={4}>
                        <p>
                          <b>GrossTotalRound:</b>{" "}
                          {parseFloat(
                            posSaleData?.returnCal?.grossTotalRound || 0
                          )?.toFixed(2)}
                        </p>
                      </Col>
                      <Col xs={12} md={2}>
                        <p>
                          <b>Point:</b> {posSaleData?.returnCal?.point || 0}
                        </p>
                      </Col>
                    </Row>
                  )}
                </>
              ) : (
                <Row>
                  <Col lg={12}>
                    <p className="text-center">Please Scan an Invoice</p>
                  </Col>
                </Row>
              )}
            </Container>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="dark" onClick={handleClose}>
            Create Return
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ReturnModal;
